export default __webpack_public_path__ + "static/media/maor-gift.a541c18f.webp";